import React, { Component } from 'react'
import axios from 'axios'

import SummaryBox from './SummaryBox'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

class RevenueSummary extends Component {

    constructor(props){
        super(props)
        this.state = {
            charity: null,
            data: null,
            loading: false,
            error: ''
        }
    }

    componentDidMount(){
        this.loadRevenue()
        this.loadDonation()
    }

    loadRevenue = () => {
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + 'summary/revenue-summary', { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200){
                this.setState({ error: response.data.message })
            }else{
                this.setState({ data: { ...response.data } })
            }
		})
		.catch((err) => {
			this.setState({ error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
		})
    }

    loadDonation = () => {
        this.setState({
            loading: true
        }, 
        () => {
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
            return axios.get(REACT_APP_API_URL + 'charity', { headers: AUTH_HEADER })
            .then((response) => {
                if(response.status !== 200){
                    this.setState({ loading: false, error: response.data.message })
                }else{
                    this.setState({ loading: false, charity: { ...response.data.charity } })
                }
            })
            .catch((err) => {
                this.setState({ loading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            })
        }
        )
    }

    showData = () => {
        return Object.keys(this.state.data).map(key => {
            const item = this.state.data[key]
            return <SummaryBox key={key} title={item.title} value={item.total} />
        })
    }

    render() {

        return (
            <div className="chart_area">
                <div className="summary_area chart">
                    {this.state.error && (
                        <div className="error">
                            {Object.keys(this.state.error).map(key => 
                                <span key={key}>{this.state.error[key]}</span>
                            )}
                        </div>
                    )}
                    {this.state.data && this.showData()}
                </div>
            </div>
        )
    }
}

export default RevenueSummary



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/RevenueSummary.js